// extracted by mini-css-extract-plugin
export default {"Link":"LinkStyles_Link__6HCGF","LinkPopup":"LinkStyles_LinkPopup__xYCxD","RemoveLink":"LinkStyles_RemoveLink__GJ0ct","Img":"LinkStyles_Img__Nok3K"};